import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";

class CompanyUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const company: CompanyInterface = CompanyFactory.create(props.res);
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SUCCESS,
      payload: {
        company: company
      }
    });
  }

}

export { CompanyUpdate };
